import { render, staticRenderFns } from "./step2.vue?vue&type=template&id=47794a16&scoped=true&"
import script from "./step2.vue?vue&type=script&lang=ts&"
export * from "./step2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47794a16",
  null
  
)

export default component.exports